import { useEffect, useState } from 'react';
import { useDialog } from "react-st-modal";
import MODAL_TABLE from '../modal/modal_Table';
import { useGoogleAuth } from './useGoogleAuth';

interface ExportProps {
  nametable: string;
  row: Record<string, any>[];
}

export const EXPORT_GS_TS = ({ nametable, row }: ExportProps) => {
  const [modalT, setModalT] = useState(false);
  const dialog = useDialog();

  const { gapi, gapiReady, requestAccessToken, tokenClient } = useGoogleAuth();

 
  useEffect(() => {
    if (tokenClient && !gapiReady) {
      requestAccessToken(); // solo se llama cuando el tokenClient ya existe
    }
    if (gapiReady) {
      handleCreateSheet(); // solo continúa cuando ya hay token y gapi está listo
    }
  }, [tokenClient, gapiReady]);

  const handleCreateSheet = () => {

      console.log("nuevo metodo tsx")

    setModalT(true);
    gapi.client.sheets.spreadsheets.create({
      properties: { title: nametable }
    }).then((response: any) => {
      const spreadsheetId = response.result.spreadsheetId;
      const spreadsheetUrl = response.result.spreadsheetUrl;
      renameFirstSheet(spreadsheetId, "Sheet", spreadsheetUrl);
    }).catch((error: any) => {
      alert("No se logró crear la hoja de cálculo.");
      console.error('Error al crear hoja:', error);
      setModalT(false);
    });
  };

  const renameFirstSheet = (spreadsheetId: string, newSheetName: string, url: string) => {
    gapi.client.sheets.spreadsheets.batchUpdate({
      spreadsheetId,
      requests: [{
        updateSheetProperties: {
          properties: { sheetId: 0, title: newSheetName },
          fields: 'title'
        }
      }]
    }).then(() => {
      updateSheet(spreadsheetId, url);
    });
  };

  const updateSheet = (spreadsheetId: string, url: string) => {
    const values = transformDataToJsonFormat(row);
    gapi.client.sheets.spreadsheets.values.update({
      spreadsheetId,
      range: "Sheet",
      valueInputOption: "USER_ENTERED",
      resource: { values }
    }).then(() => {
      setModalT(false);
      window.open(url, '_blank');
      dialog.close(true);
    }).catch((error: any) => {
      alert("No se logró actualizar la hoja.");
      console.error(error);
      setModalT(false);
    });
  };

  const transformDataToJsonFormat = (jsonData: Record<string, any>[]): any[][] => {
    if (jsonData.length === 0) return [];
    const headers = Object.keys(jsonData[0]).filter(key =>
      ['string', 'number', 'boolean'].includes(typeof jsonData[0][key]) ||
      jsonData[0][key] === null || jsonData[0][key] === undefined
    );
    const rows = jsonData.map(item =>
      headers.map(header => {
        const val = item[header];
        return typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean' ? val : '';
      })
    );
    return [headers, ...rows];
  };

  return (
    <div>
      <MODAL_TABLE
        open={true}
        message={"Exportando a Google..."}
        message2={""}
        modalGeneral={false}
        modalT={modalT}
      />
    </div>
  );
};
